module.exports = __webpack_public_path__ + "media/recipes/90-109397a9.png";